<template>
    <div class="chart-container">
        <canvas ref="canvasRef"></canvas>
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, watch, ref } from 'vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const props = defineProps({
    chartData: {
        type: Object,
        required: true
    },
    options: {
        type: Object,
        default: () => ({})
    }
})

const canvasRef = ref(null)
let chartInstance = null

const createChart = () => {
    if (chartInstance) {
        chartInstance.destroy()
    }

    const mergedOptions = {
        locale: 'es-ES',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                display: true
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    // Permet que el max s’adapti als valors de forma dinàmica
                    callback: function(value) {
                        return value
                    }
                }
            },
            x: {
                ticks: {
                    autoSkip: false // mostra totes les etiquetes
                }
            }
        },
        ...props.options
    }

    chartInstance = new Chart(canvasRef.value.getContext('2d'), {
        type: 'bar',
        data: props.chartData,
        options: mergedOptions
    })
}

onMounted(createChart)

watch(
    () => props.chartData,
    () => {
        createChart()
    },
    { deep: true }
)

onBeforeUnmount(() => {
    if (chartInstance) {
        chartInstance.destroy()
    }
})
</script>

<style scoped>
.chart-container {
    position: relative;
    width: 100%;
    height: 360px; /* més controlat que 400px per evitar Canvas oversize */
}
</style>
